import React from "react";
import { Truck } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useShipping } from "@/context/ShippingContext";
import { formatPrice } from "@/lib/api";

const AnnouncementBar = () => {
  const { lang } = useLang();
  const { free_shipping_threshold } = useShipping();

  return (
    <div className="bg-charcoal text-bone py-2.5" role="status">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-3 text-center">
        <Truck size={15} strokeWidth={1.5} className="text-champagne shrink-0" />
        <p className="text-[10px] md:text-xs uppercase tracking-[0.22em]">{lang === "it" ? `Spedizione gratuita a partire da ${formatPrice(free_shipping_threshold)}` : `Free shipping on orders over ${formatPrice(free_shipping_threshold)}`}</p>
      </div>
    </div>
  );
};

export default AnnouncementBar;
